import { LineStyle, Color, LineKinds } from "../../drawing";
import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { ILineDrawable } from "./ILineDrawable";
import { TypeKeys } from "./TypeKeys";

export class CrossItem extends AbstractRectangleItem implements ILineDrawable {
  constructor() {
    super(TypeKeys.CrossItem);
  }

  public lineStyle: LineStyle = new LineStyle(new Color("#000000"), LineKinds.Normal, 2);

  protected createCloneInstance(): CrossItem {
    return new CrossItem();
  }

  protected applyMembers(clone: CrossItem): void {
    super.applyMembers(clone);
    clone.lineStyle = this.cloneValue(this.lineStyle);
  }
}
